export default function Footer() {
  return (
    <footer className="border-t text-center italic text-sm p-2">
      the free cashews: 🍲 grashew design is my pashew 🍲
    </footer>
  );
}
